<template>
  <ChecklistDailyView
    :view-only="isViewOnlyUser"
    @update-completed="$emit('update-completed', $event)"
  />
</template>

<script>
import { mapState } from 'vuex';
import ChecklistDailyView from './ChecklistDailyView.vue'

export default {
  name: 'TodayTab',
  components: {
    ChecklistDailyView
  },
  computed: {
    ...mapState(["userInfo"]),
    
    isViewOnlyUser() {
      return this.$store.state.userInfo.role !== '11'
    },
  }
}
</script>